import { FC } from 'react';
import { CallIntelTypes } from '@frontend/api-call-intel';
import { CheckListFilterSelector } from '@frontend/analytics-shared';
import { useTranslation } from '@frontend/i18n';
import { trackingIds } from '../../../../../tracking-ids';
import { FilterTraySection } from '../filter-tray-section/filter-tray-section';
import { useSchedulingOutcomeFilterData } from './use-scheduling-outcome-filter-data';

export const SchedulingOutcomeFilterTray: FC<{ disabled?: boolean; showClear?: boolean }> = ({
  disabled,
  showClear = true,
}) => {
  const { t } = useTranslation('call-intelligence');
  const { value: selectedValues, schedulingOutcomeOptions, isLoading, onChange } = useSchedulingOutcomeFilterData();

  const isDisabled = disabled || isLoading;

  return (
    <FilterTraySection
      label={t('Scheduling Outcome')}
      disableClear={isDisabled}
      showClear={showClear}
      onClear={() => onChange([])}
    >
      <CheckListFilterSelector<CallIntelTypes.SchedulingOutcomeV2Enum>
        label={t('Scheduling Outcome')}
        onChange={onChange}
        options={schedulingOutcomeOptions}
        showLabel={false}
        trackingIdBase={trackingIds.callIntel.schedulingOutcomesFilter}
        value={selectedValues}
        disabled={isDisabled}
      />
    </FilterTraySection>
  );
};
